module.exports = __webpack_public_path__ + "static/media/dopuszczenie-HC.de9620ab.svg";